import SelectInput from "./SelectInput"
import countryList from "../../../utils/countryList"

const CountrySelectInput = ({...props}) => {
   
    props.options = countryList;
    
    return (
        <SelectInput {...props}/>
    );
};

export default CountrySelectInput;